var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorBoundary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 147,
    viewBox: "0 0 149 147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -5)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.955 18.847c-.065-.562-.696-.839-1.125-.498l-6.546 5.115c-2.568 2.006-6.226 2.007-8.528-.113-2.954-2.723-2.735-7.376.379-9.809l6.793-5.307c.428-.334.316-1.016-.2-1.21-5.452-2.03-11.582-.624-15.646 3.857-3.01 3.307-4.243 7.979-3.336 12.41a1.668 1.668 0 01-.594 1.652L59.51 49.666a5.423 5.423 0 00-.934 7.605 5.423 5.423 0 007.605.933l31.666-24.73a1.668 1.668 0 011.748-.177c4.865 2.322 10.65 1.756 14.97-1.61a14.282 14.282 0 005.39-12.84zM49.586 86.618l3.395-8.394 13.701.65 5.477-6.085-2.078-13.558 7.995-4.248 10.078 9.304 8.104-1.14 7.125-11.722 8.857 1.882 1.74 13.607 6.941 4.336 12.992-4.4 5.575 7.135-7.414 11.543 2.529 7.78 12.781 4.98-.317 9.05-13.098 4.077-3.064 7.587 6.59 12.032-6.059 6.727-12.656-5.296-7.224 3.843-2.685 13.453-8.968 1.258-6.288-12.188-8.005-1.702-10.704 8.58-7.676-4.8 3.019-13.381-5.041-6.45-13.715-.308-2.795-8.612 10.914-8.31.285-8.18-10.31-9.05zm40.847 12.966a7.182 7.182 0 1014.05 2.987 7.182 7.182 0 00-14.05-2.987z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4A4A4A",
    cx: 97,
    cy: 101,
    r: 31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38 51.969L0 42.519l4.527-7.841L16.9 37.21l5.594-3.23L26.49 22h9.055l3.993 11.982 5.592 3.23 12.375-2.533 4.527 7.842-8.378 9.45v6.458l8.38 9.45-4.528 7.84-12.373-2.532-5.594 3.23L35.544 88.4h-9.055l-3.993-11.982-5.593-3.23L4.53 75.72.002 67.88l8.378-9.45v-6.461zm28.509 3.23a5.872 5.872 0 00-5.873-5.872 5.872 5.872 0 00-5.872 5.873 5.872 5.872 0 005.872 5.873A5.872 5.872 0 0036.89 55.2z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4A4A4A",
    cx: 31,
    cy: 55,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.84 53.901l13.464 3.422m-12.369-6.857L90.5 49.5",
    stroke: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.524 37.781L62.5 27.5",
    stroke: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.534 39.497l5.036-14.684",
    stroke: "#525252"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBoundary);
export default __webpack_public_path__ + "static/media/ErrorBoundary.769b4c9eea8b6251c62be97ed4a187c0.svg";
export { ForwardRef as ReactComponent };